// extracted by mini-css-extract-plugin
module.exports = {"loading-container":"styles_loading-container__294pC","page__loading__backdrop":"styles_page__loading__backdrop__p4QGc"};